module.exports = require("rcon-srcds");